import { render, staticRenderFns } from "./RestaurantLocationsSection.vue?vue&type=template&id=313b1d2a&scoped=true&"
import script from "./RestaurantLocationsSection.vue?vue&type=script&lang=js&"
export * from "./RestaurantLocationsSection.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantLocationsSection.vue?vue&type=style&index=0&id=313b1d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b1d2a",
  null
  
)

export default component.exports